module.exports = __webpack_public_path__ + "static/media/bgMusic1.8373bea7.mp3";